import { once } from "../Services";
import { Activity } from "./Activity";
export class SecretActivity extends Activity {
    constructor(isCompleted, title, points, image, statement, patterns) {
        super();
        this.isCompleted = isCompleted;
        this.title = title;
        this.points = points;
        this.image = image;
        this.statement = statement;
        this.patterns = patterns;
        this.getRegexps = once(() => {
            return this.patterns.map(pattern => new RegExp(...pattern));
        });
    }
    checkAnswer(answer) {
        answer = answer.trim();
        return this.getRegexps().some(regexp => {
            return regexp.test(answer);
        });
    }
}
